import { prependWithMessage, shouldSwallowException } from 'client/utilities/error'
import { useCallback, useState } from 'react'

// Use this to throw new Errors from within an async function, as the Errorboundary doesnt pick up on errors thrown from within async fucntions
export const useAsyncError = () => {
  const [error, setError] = useState<Error | string>()
  if (error) {
    if (!shouldSwallowException(error)) {
      throw error
    }
  }

  const throwError = useCallback((e: Error | string, message?: string) => {
    if (message != null) {
      if (e instanceof Error) {
        prependWithMessage(e, message)
      } else {
        throwError(new Error(e), message)
        return
      }

      setError(e)
    }
  }, [])

  return throwError
}
